import ConfigManagement from './ConfigManagement';

export default ConfigManagement;
